const responsiveAccordionClassName = {
    '&.Mui-expanded, &.Mui-expanded .MuiCollapse-root, &.Mui-expanded .MuiCollapse-wrapper, &.Mui-expanded .MuiCollapse-wrapperInner, &.Mui-expanded .MuiAccordion-region, &.Mui-expanded .MuiAccordionDetails-root': {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
};

export default responsiveAccordionClassName;
